import { render, staticRenderFns } from "./AddMemo.vue?vue&type=template&id=818044a0&"
import script from "./AddMemo.vue?vue&type=script&lang=js&"
export * from "./AddMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports